import { z } from 'zod';

import {
	SearchProcessesSortV3NameEnum,
	SortOrderTypeV1x0,
} from '../../../api/generated/cz.partners.pid.backofficegateway.pidonboarding';

export const applicationsActivationsSortSchema = z
	.object({
		name: z.enum(SearchProcessesSortV3NameEnum),
		order: z.enum(SortOrderTypeV1x0),
	})
	.catch({
		name: SearchProcessesSortV3NameEnum.CREATED_AT,
		order: SortOrderTypeV1x0.DESC,
	});

export type ActivateApplicationSort = z.infer<
	typeof applicationsActivationsSortSchema
>;
